export default __webpack_public_path__ + "static/media/bisleri.5b8b6d96.png";